import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRegisterMutation } from "../../redux/slices/usersApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../../redux/slices/authSlice";
import { toast } from "react-toastify";
import "react-toastify/ReactToastify.css";
import EmailForm from "../../components/Email/EmailForm";
import VerificationForm from "../../components/Email/VerificationForm";
import styles from "./Register.module.css";
import Mekke from "../../assets/pngs/mekke.jpg";
import Logo from "../../assets/svgs/tevhidlogo.svg";

const Register = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [register, { isLoading }] = useRegisterMutation();
  const { userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    if (userInfo) {
      navigate("/dashboard");
    }
  }, [navigate, userInfo]);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error('Şifreler uyuşmuyor.');
      return;
    }
    try {
      const res = await register({ name, email, password }).unwrap();
      dispatch(setCredentials({ ...res }));
      toast.success('Kayıt işlemi başarılı.');
      navigate("/login");  // Redirect to login after registration
    } catch (error) {
      console.error('Register error:', error);
      toast.error('Kayıt işlemi başarısız.');
    }
  };

  const handleEmailNext = (email) => {
    setEmail(email);
    setStep(2);
  };

  const handleVerificationNext = () => {
    setStep(3);
  };

  return (
    <section className={styles.container}>
      <div className={styles.background}>
        <img src={Mekke} alt="Background" className={styles.backgroundImage} />
        <div className={styles.overlay}></div>
      </div>
      <div className={styles.foregroundImage}>
        {step === 1 && <EmailForm onNext={handleEmailNext} />}
        {step === 2 && <VerificationForm email={email} onNext={handleVerificationNext} />}
        {step === 3 && (
          <div className={styles.auth}>
            <img src={Logo} alt="Logo" />
            <h1>Kitap Stok - Kayıt Ol</h1>
            <form onSubmit={handleRegister}>
              <input
                type="text"
                name="name"
                placeholder="İsim"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="text"
                name="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                readOnly
              />
              <input
                type="password"
                name="password"
                placeholder="Şifre"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <input
                type="password"
                name="confirmPassword"
                placeholder="Şifreyi Onayla"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button type="submit" disabled={isLoading}>
                {isLoading ? 'Kayıt yapılıyor...' : 'Kayıt ol'}
              </button>
            </form>
            <p className={styles.loginmessage} onClick={() => navigate('/login')}>
              <span>Giriş Yap</span>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Register;
